import { AdminModule } from './pages/admin/admin.module';
import { Routes } from '@angular/router';
import { TemplateComponent as PublicTemplate } from './pages/public/template/template.component';
import { TemplateComponent as AdminTemplate } from './pages/admin/template/template.component';
import { PageNotFoundComponent } from './pages/public/common/page-not-found/page-not-found.component';
import { AuthComponent } from './pages/public/auth/auth.component';
import { DownloadComponent } from './pages/public/download/download.component';
import { authGuard } from './guards/auth.guard';
import { sessionGuard } from './guards/session.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/public/public.module').then(m=>m.PublicModule),
    component : PublicTemplate
  },
  {
    path: 'download',
    component: DownloadComponent,
    title: 'Download | Philippine Vex Robotics'
  },
  {
    path: 'admin',
    canActivate: [authGuard, sessionGuard],
    loadChildren: () => import('./pages/admin/admin.module').then(m=>m.AdminModule),
    component : AdminTemplate
  },
  {
    path: 'login',
    component: AuthComponent,
    title: 'Vex Login'
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    title: 'Page Not Found'
  }
];
